module.exports = "/images/logo-dueruote.png?29b102addb920dbc60fb19d82fd2b49f";


//////////////////
// WEBPACK FOOTER
// ./resources/images/project-img/logo-dueruote.png
// module id = oFyg
// module chunks = 1